import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../utils/translations';

const LanguageContext = createContext();

const LANGUAGE_KEY = 'footparadise_language';

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(null); // null means not selected yet
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if language was previously selected
    const savedLanguage = localStorage.getItem(LANGUAGE_KEY);
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'es')) {
      setLanguage(savedLanguage);
    }
    setIsLoading(false);
  }, []);

  const selectLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem(LANGUAGE_KEY, lang);
  };

  const t = (key) => {
    if (!language) return translations['en'][key] || key;
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  const resetLanguage = () => {
    setLanguage(null);
    localStorage.removeItem(LANGUAGE_KEY);
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      selectLanguage, 
      t, 
      isLoading,
      hasSelectedLanguage: language !== null,
      resetLanguage
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
